import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';
import { AssociatedBox, AssociatedIconContainer } from './styles';

function AssociatedBlockComponent({
    icon,
    primaryTitle,
    primaryContent,
    secondaryTitle,
    secondaryContent,
    action,
    primaryContentColor,
    hideSecondaryLabel
}) {
    const color = primaryContentColor || 'default';

    const typographyStyle = {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
        // maxWidth: '200px'
    };

    return (
        <AssociatedBox sx={{ justifyContent: 'space-between' }}>
            <Box display="flex">
                {icon && (
                    <AssociatedIconContainer>{icon}</AssociatedIconContainer>
                )}
                <Box display="flex" gap={1} ml={2} mr={2}>
                    {primaryTitle && primaryContent && (
                        <Box display="flex" flexDirection="column">
                            <Typography variant="subtitle2">
                                {primaryTitle}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={(theme) => ({
                                    color: theme.palette.text[color],
                                    ...typographyStyle
                                })}
                                title={primaryContent}
                                onCopy={(e) => {
                                    e.preventDefault();
                                    navigator.clipboard.writeText(primaryContent);
                                }}
                            >
                                {secondaryContent && primaryContent.length > 15
                                    ? `${primaryContent.slice(0, 15)}...`
                                    : primaryContent}
                            </Typography>
                        </Box>
                    )}

                    {secondaryTitle && secondaryContent && (
                        <Box display="flex" flexDirection="column">
                            <Box sx={{ height: '22px' }}>
                                {!hideSecondaryLabel && (
                                    <Typography variant="subtitle2" color="textPrimary">
                                        {secondaryTitle}
                                    </Typography>
                                )}
                            </Box>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                title={secondaryContent}
                                onCopy={(e) => {
                                    e.preventDefault();
                                    navigator.clipboard.writeText(
                                        secondaryContent
                                    );
                                }}
                                sx={typographyStyle}
                            >
                                • {'  '}
                                {secondaryContent.length > 15 &&
                                primaryContent.length > 0
                                    ? `${secondaryContent.slice(0, 15)}...`
                                    : secondaryContent}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
            {action && (
                <Box display="flex" marginLeft="auto" flexShrink={0}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={action.onClick}
                    >
                        {action.label}
                    </Button>
                </Box>
            )}
        </AssociatedBox>
    );
}

AssociatedBlockComponent.propTypes = {
    icon: PropTypes.node,
    primaryTitle: PropTypes.string.isRequired,
    primaryContent: PropTypes.string.isRequired,
    secondaryTitle: PropTypes.string,
    secondaryContent: PropTypes.string,
    primaryContentColor: PropTypes.oneOf(['highlighted', 'primary', 'default']),
    action: PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired
    })
};

AssociatedBlockComponent.defaultProps = {
    icon: null,
    secondaryTitle: null,
    secondaryContent: null,
    action: null
};

export default memo(AssociatedBlockComponent);
